import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http'
import { Observable,throwError as observableThrowError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class NPlabsService {

  constructor(private _http:HttpClient) { }
  getNPlasbsData():Observable<any>{

    let FullUrl = localStorage.getItem('BaseUrl')+"/api/NPLab/GetAllNPLabs";
    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };

    return this._http.get(FullUrl,requestOptions );
  }
  createNPlasbsData(data:any):Observable<any>{

    let FullUrl = localStorage.getItem('BaseUrl')+"/api/NPLab/CreateNPLab";
    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };

    return this._http.post(FullUrl,data,requestOptions );
  }
  nplabUpdate(data:any):Observable<any>{

    let FullUrl = localStorage.getItem('BaseUrl')+"/api/NPLab/UpdateNPLab";
    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };

    return this._http.post(FullUrl,data,requestOptions );
  }
}
